import { render, staticRenderFns } from "./notification.html?vue&type=template&id=cdc89a06&scoped=true&"
import script from "./notification.js?vue&type=script&lang=js&"
export * from "./notification.js?vue&type=script&lang=js&"
import style0 from "./notification.scss?vue&type=style&index=0&id=cdc89a06&lang=scss&scoped=true&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"
import style2 from "./notification.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc89a06",
  null
  
)

export default component.exports